import React from 'react';
import { makeStyles, Container, Typography, Grid, Dialog, Button } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import customAxios from "../../../../components/API/customAxios"
import { useIntl } from 'react-intl';
import { DialogTitle, globalDialogStyle, messageBoxDialogStyle, DialogContent } from "../../../UIComponent/CommonStyle"

const useStyles = makeStyles((theme) => ({
    ...globalDialogStyle(theme),
    ...messageBoxDialogStyle(theme),
    dialogPaper: {
        minWidth: 'auto',
        maxWidth: 'auto',
    },
    dialogContent: {
        ...globalDialogStyle(theme).dialogContent,
        width: 'auto',
        height: 'auto',
    },
}));

export default function ConfirmBox({ editApplicationId, open, handleClose, action, backToTable, page, isNewCompLeave, pageClose }) {
    const classes = useStyles();
    const intl = useIntl();
    const [showAfterSubmittion, setShowAfterSubmittion] = React.useState(false);
    const [isError, setError] = React.useState(false);
    const [submitDisabled, setSubmitDisabled] = React.useState(false);
    const [submitButtonText, setSubmitButtonText] = React.useState(intl.formatMessage({ id: 'waring.yes' }));
    const [confirmText, setConfirmText] = React.useState();
    const [afterSubmittedText, setAfterSubmittedText] = React.useState();
    const [seconds, setSeconds] = React.useState(5);
    const isCompLeaveAction = ['Comp Leave Reqs', 'Employee Record'].includes(page);

    React.useEffect(() => {
        switch (action) {
            case 'withdraw':
                setConfirmText(intl.formatMessage({ id: 'confirmation.withdraw' }));
                setAfterSubmittedText(intl.formatMessage({ id: 'after_submitted_withdrawn' }));
                break;
            case 'cancel':
                setConfirmText(intl.formatMessage({ id: 'confirmation.cancel' }));
                setAfterSubmittedText(intl.formatMessage({ id: 'after_submitted_cancelled' }));
                break;
        }
    }, [action])

    const handleSubmit = () => {
        setSubmitDisabled(true);
        setSubmitButtonText(intl.formatMessage({ id: 'waiting' }));
        const withdrawPath = isCompLeaveAction || isNewCompLeave ? '/withdraw_comp_leave_req/' : '/withdraw_application/';
        const cancelPath = isCompLeaveAction || isNewCompLeave ? '/cancel_comp_leave_req/' : '/cancel_application/';

        switch (action) {
            case 'withdraw':
                customAxios.post(withdrawPath + editApplicationId)
                    .then(res => {
                        const status = res.status
                        if (status === 201) {
                            setShowAfterSubmittion(true);
                            setTimeout(function () { window.location.reload(); }, 3000);
                        }
                    }, error => {
                        if (error.response.status === 500) {
                            setShowAfterSubmittion(true);
                            setError(true);
                            setTimeout(function () { window.location.reload(); }, 3000);
                        }
                    });
                break;
            case 'cancel':
                customAxios.post(cancelPath + editApplicationId)
                    .then(res => {
                        const status = res.status
                        if (status === 201) {
                            setShowAfterSubmittion(true);
                            if (pageClose) {
                                let countdownInterval = setInterval(function() {
                                    setSeconds(prevSeconds => {
                                        if (prevSeconds === 1) {
                                            clearInterval(countdownInterval);
                                            window.close();
                                        }
                                        return prevSeconds - 1;
                                    });
                                }, 1000);
                            } else {
                                setTimeout(function () { backToTable(); }, 3000);
                            }
                        }
                    }, 
                    error => {
                        if (error.response.status === 500) {
                            setShowAfterSubmittion(true);
                            setError(true);
                            setTimeout(function () { window.location.reload(); }, 3000);
                        }
                    }
                );
                break;
        }
    }

    return (
        <Container className={classes.container} variant="outlined">
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} classes={{ paper: classes.dialogPaper }}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {intl.formatMessage({ id: 'confirmation' })}
                </DialogTitle>
                {!showAfterSubmittion ?
                    <DialogContent dividers>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                {isCompLeaveAction 
                                    ? <Typography>{intl.formatMessage({ id: 'comp_leave.confirmation_1' }) + confirmText + intl.formatMessage({ id: 'comp_leave.confirmation_2' })}</Typography>
                                    : <Typography>{intl.formatMessage({ id: 'leave_approval.confirmation_1' }) + confirmText + intl.formatMessage({ id: 'leave_approval.confirmation_2' })}</Typography>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <div className={classes.yesButton}>
                                    <Button
                                        disabled={submitDisabled}
                                        variant="contained"
                                        style={{ backgroundColor: 'green', color: '#FFF' }}
                                        size="small"
                                        startIcon={<CheckCircleIcon />}
                                        onClick={handleSubmit}
                                    >
                                        {submitButtonText}
                                    </Button>
                                    <Button
                                        className={classes.noButton}
                                        variant="contained"
                                        color="secondary"
                                        size="small"
                                        startIcon={<CancelIcon />}
                                        onClick={handleClose}
                                    >
                                        {intl.formatMessage({ id: 'waring.no' })}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    :
                    <DialogContent className={classes.afterSubmitPage} dividers>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {!isError ? (
                                    <>
                                        <Typography className={classes.title}>
                                            {intl.formatMessage({ id: 'confirmation.applicaion' })}{afterSubmittedText}
                                        </Typography>
                                        {pageClose && (
                                            <Typography className={classes.title}>
                                                {intl.formatMessage(
                                                    { id: 'cancel_alert.page_close_count_down' },
                                                    { seconds: seconds},
                                                )}
                                            </Typography>
                                        )}
                                    </>
                                ) : (
                                    <Typography className={classes.title}>
                                        {intl.formatMessage({ id: 'error.cannot_change_status' })}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                {!isError ? <CheckCircleIcon style={{ fontSize: '100px', color: 'green' }} /> : <CancelIcon color="secondary" style={{ fontSize: '100px' }} />}
                            </Grid>
                        </Grid>
                    </DialogContent>
                }
            </Dialog>
        </Container>
    )
}
